import React from 'react'
import {DrawerHeaderProps} from '../utils/types'

const DrawerHeader: React.FC<DrawerHeaderProps> = ({title, onClose}) => {
  return (
    <div
      className='modal-dialog-centered border-bottom border-gray-300'
      style={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        padding: '14px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: '15px',
        paddingRight: '12px',
        zIndex: 5,
      }}
    >
      <div className='fs-4 fw-bold mx-2' style={{margin: 0}}>
        {title}
      </div>
      <div style={{display: 'flex', gap: '16px'}}>
        <div
          className='btn btn-icon btn-sm btn-active-light-primary'
          onClick={onClose}
          aria-label='Close'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#5A5A5A'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M18 6l-12 12' />
            <path d='M6 6l12 12' />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default DrawerHeader
